// "Straight to your bank", drawn as the moment it happens: a bank picker card
// with the banks people actually use as full colour app tiles, one selected,
// and the transfer button. A graphic, not a row of grey logos (founder
// 2026-10-03: "really graphical, like it's a bank logo").
//
// ⚠️ FOUNDER DECISION 2026-10-03, trademark risk accepted. Other companies'
// marks, so the guard rails are:
//   • The claim is FACTUAL (payouts go to any UK current account). Never
//     "partner", "trusted by" or "backed by".
//   • Every tile is the same size and treatment; no bank is singled out as
//     endorsing us. The selected one is the illustration's own choice.
//   • The "no affiliation implied" line stays directly underneath.
// Remove any bank whose owner asks, no argument.
//
// Marks + brand hex: Simple Icons v16.33.0 (simple-icons.org; CC0 for the
// drawing, the trademarks belong to their owners), fetched 2026-10-03. Inlined,
// so the site makes no third party request. Monzo's tile is its navy with the
// coral mark, Wise its lime with the forest mark, as their own icons are.
//
// ⛔ Deliberately absent: our payments provider's badge. House rule (see
// ds/TrustMarks.jsx): never name a vendor in user facing copy.
//
// aria-hidden on the card: it is a picture of an interface. The heading and the
// sentence beside it carry the meaning.

const BANKS = [
  { name: 'Monzo', bg: '#14233C', fg: '#FF4F40', d: 'M4.244 1.174a.443.443 0 00-.271.13l-3.97 3.97-.001.001c3.884 3.882 8.093 8.092 11.748 11.748v-8.57L4.602 1.305a.443.443 0 00-.358-.131zm15.483 0a.443.443 0 00-.329.13L12.25 8.456v8.568L24 5.275c-1.316-1.322-2.647-2.648-3.97-3.97a.443.443 0 00-.301-.131zM0 5.979l.002 10.955c0 .294.118.577.326.785l4.973 4.976c.28.282.76.083.758-.314V12.037zm23.998.003l-6.06 6.061v10.338c-.004.399.48.6.76.314l4.974-4.976c.208-.208.326-.49.326-.785z' },
  { name: 'Barclays', bg: '#00AEEF', fg: '#FFFFFF', d: 'M21.043 3.629a3.235 3.235 0 0 0-1.048-.54 3.076 3.076 0 0 0-.937-.144h-.046c-.413.006-1.184.105-1.701.71a1.138 1.138 0 0 0-.226 1.023.9.9 0 0 0 .555.63s.088.032.228.058c-.04.078-.136.214-.136.214-.179.265-.576.612-1.668.612h-.063c-.578-.038-1.056-.189-1.616-.915-.347-.45-.523-1.207-.549-2.452-.022-.624-.107-1.165-.256-1.6-.1-.29-.333-.596-.557-.742a2.55 2.55 0 0 0-.694-.336c-.373-.12-.848-.14-1.204-.146-.462-.01-.717.096-.878.292-.027.033-.032.05-.068.046-.084-.006-.272-.006-.328-.006-.264 0-.498.043-.721.09-.47.1-.761.295-1.019.503-.12.095-.347.365-.399.653a.76.76 0 0 0 .097.578c.14-.148.374-.264.816-.266.493-.002 1.169.224 1.406.608.336.547.27.99.199 1.517-.183 1.347-.68 2.048-1.783 2.203-.191.026-.38.04-.56.04-.776 0-1.34-.248-1.63-.716a.71.71 0 0 1-.088-.168s.087-.021.163-.056c.294-.14.514-.344.594-.661.09-.353.004-.728-.23-1.007-.415-.47-.991-.708-1.713-.708-.4 0-.755.076-.982.14-.908.256-1.633.947-2.214 2.112-.412.824-.7 1.912-.81 3.067-.11 1.13-.056 2.085.019 2.949.124 1.437.363 2.298.708 3.22a15.68 15.68 0 0 0 1.609 3.19c.09-.094.15-.161.308-.318.188-.19.724-.893.876-1.11.19-.27.51-.779.664-1.147l.15.119c.16.127.252.348.249.592-.003.215-.053.464-.184.922a8.703 8.703 0 0 1-.784 1.818c-.189.341-.27.508-.199.584.015.015.038.03.06.026.116 0 .34-.117.585-.304.222-.17.813-.672 1.527-1.675a15.449 15.449 0 0 0 1.452-2.521c.12.046.255.101.317.226a.92.92 0 0 1 .08.563c-.065.539-.379 1.353-.63 1.94-.425.998-1.208 2.115-1.788 2.877-.022.03-.163.197-.186.227.9.792 1.944 1.555 3.007 2.136.725.408 2.203 1.162 3.183 1.424.98-.262 2.458-1.016 3.184-1.424a17.063 17.063 0 0 0 3.003-2.134c-.05-.076-.13-.158-.183-.23-.582-.763-1.365-1.881-1.79-2.875-.25-.59-.563-1.405-.628-1.94-.028-.221-.002-.417.08-.565.033-.098.274-.218.317-.226.405.884.887 1.73 1.452 2.522.715 1.003 1.306 1.506 1.527 1.674.248.191.467.304.586.304a.07.07 0 0 0 .044-.012c.094-.069.017-.234-.183-.594a9.003 9.003 0 0 1-.786-1.822c-.13-.456-.18-.706-.182-.92-.004-.246.088-.466.248-.594l.15-.118c.155.373.5.919.665 1.147.15.216.685.919.876 1.11.156.158.22.222.308.32a15.672 15.672 0 0 0 1.609-3.19c.343-.923.583-1.784.707-3.222.075-.86.128-1.81.02-2.948-.101-1.116-.404-2.264-.81-3.068-.249-.49-.605-1.112-1.171-1.566z' },
  { name: 'HSBC', bg: '#DB0011', fg: '#FFFFFF', d: 'm24 12.007-5.996 5.997V5.996L24 12.007zm-5.996-6.01H6.01l5.996 6.01 5.997-6.01zM0 12.006l6.01 5.997V5.996L0 12.007zm6.01 5.997h11.994l-5.997-5.997-5.996 5.997z' },
  { name: 'Starling', bg: '#6935D3', fg: '#FFFFFF', d: 'M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm2.738 3.822h.666v2.724h-.666a4.794 4.794 0 0 0-4.789 4.788V12H7.226v-.666c0-4.142 3.37-7.512 7.512-7.512zM14.05 12h2.723v.666c0 4.142-3.37 7.512-7.512 7.512h-.666v-2.724h.666a4.794 4.794 0 0 0 4.789-4.788z' },
  { name: 'Revolut', bg: '#191C1F', fg: '#FFFFFF', d: 'M20.9133 6.9566C20.9133 3.1208 17.7898 0 13.9503 0H2.424v3.8605h10.9782c1.7376 0 3.177 1.3651 3.2087 3.043.016.84-.2994 1.633-.8878 2.2324-.5886.5998-1.375.9303-2.2144.9303H9.2322a.2756.2756 0 0 0-.2755.2752v3.431c0 .0585.018.1142.052.1612L16.2646 24h5.3114l-7.2727-10.094c3.6625-.1838 6.61-3.2612 6.61-6.9494zM6.8943 5.9229H2.424V24h4.4704z' },
  { name: 'Chase', bg: '#117ACA', fg: '#FFFFFF', d: 'M0 15.415c0 .468.38.85.848.85h5.937V.575L0 7.72v7.695m15.416 8.582c.467 0 .846-.38.846-.849v-5.937H.573l7.146 6.785h7.697M24 8.587a.844.844 0 0 0-.847-.846h-5.938V23.43l6.782-7.148L24 8.586M8.585.003a.847.847 0 0 0-.847.847v5.94h15.688L16.282.003H8.585Z' },
  { name: 'Wise', bg: '#9FE870', fg: '#163300', d: 'M6.488 7.469 0 15.05h11.585l1.301-3.576H7.922l3.033-3.507.01-.092L8.993 4.48h8.873l-6.878 18.925h4.706L24 .595H2.543l3.945 6.874Z' },
]

const SELECTED = 'Monzo'

function Tile({ bank, size = 52 }) {
  return (
    <span
      className="flex shrink-0 items-center justify-center rounded-[16px] shadow-[0_6px_16px_rgba(12,24,41,0.14)] ring-1 ring-black/5"
      style={{ background: bank.bg, width: size, height: size }}
    >
      <svg viewBox="0 0 24 24" width={size * 0.5} height={size * 0.5} fill={bank.fg} aria-hidden="true">
        <path d={bank.d} />
      </svg>
    </span>
  )
}

export function BankPickerCard({ className = '' }) {
  const sel = BANKS.find((b) => b.name === SELECTED)
  return (
    <div aria-hidden="true" className={`w-full max-w-[400px] rounded-[24px] bg-surface p-6 shadow-[0_24px_60px_rgba(12,24,41,0.16)] ring-1 ring-hairline ${className}`}>
      <div className="flex items-baseline justify-between">
        <p className="text-[15px] font-semibold text-ink">Send to your bank</p>
        <p className="text-[13px] text-ink-muted">Available <span className="font-semibold tabular-nums text-ink">£612.40</span></p>
      </div>

      <div className="mt-5 grid grid-cols-4 gap-x-3 gap-y-4">
        {BANKS.map((b) => {
          const on = b.name === SELECTED
          return (
            <div key={b.name} className="flex flex-col items-center gap-1.5">
              <span className={`relative rounded-[19px] p-[3px] ${on ? 'ring-2 ring-action-fill' : ''}`}>
                <Tile bank={b} />
                {on && (
                  <span className="absolute -right-1 -top-1 flex h-5 w-5 items-center justify-center rounded-full bg-action-fill ring-2 ring-surface">
                    <svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="#fff" strokeWidth="3.2" strokeLinecap="round" strokeLinejoin="round"><path d="m5 12 5 5 9-10" /></svg>
                  </span>
                )}
              </span>
              <span className={`text-[12px] ${on ? 'font-semibold text-ink' : 'text-ink-muted'}`}>{b.name}</span>
            </div>
          )
        })}
        <div className="flex flex-col items-center gap-1.5">
          <span className="p-[3px]">
            <span className="flex h-[52px] w-[52px] items-center justify-center rounded-[16px] border border-dashed border-ink/20 text-[20px] font-semibold text-ink-muted">+</span>
          </span>
          <span className="text-[12px] text-ink-muted">Any bank</span>
        </div>
      </div>

      <div className="mt-5 flex items-center gap-3 rounded-[16px] bg-canvas px-4 py-3">
        <Tile bank={sel} size={36} />
        <div className="min-w-0 flex-1">
          <p className="text-[14px] font-semibold text-ink">{sel.name} ••4821</p>
          <p className="text-[12px] text-ink-muted">Instant · lands in minutes</p>
        </div>
        <p className="text-[15px] font-bold tabular-nums text-ink">£612.40</p>
      </div>

      <span className="mt-4 block rounded-full bg-action-fill py-3 text-center text-[15px] font-semibold text-white">
        Transfer to {sel.name}
      </span>
    </div>
  )
}

export function BankDisclaimer({ className = '' }) {
  return (
    <p className={`text-[12px] text-ink-muted/80 ${className}`}>
      Bank logos are trademarks of their respective owners. No affiliation or endorsement is implied.
    </p>
  )
}

// The section block: words on the left, the card on the right.
// `footnote`: pass it on a page that has no footnote of its own for the asterisk
// (Find work already carries one under the money section).
export default function BankStrip({ className = '', footnote = null }) {
  return (
    <div className={`flex flex-col gap-10 md:flex-row md:items-center md:justify-between md:gap-16 ${className}`}>
      <div className="max-w-[440px]">
        <h3 className="text-[26px] font-bold tracking-[-0.02em] md:text-[32px]">Straight to your bank. In minutes.</h3>
        <p className="mt-4 text-[17px] leading-relaxed text-ink-muted">
          Move money from your TempDash wallet to any UK current account, whether you bank with Monzo,
          Starling, Barclays or anyone else. Send it whenever you like, or pull your funds
          instantly the moment you need them.*
        </p>
        <BankDisclaimer className="mt-6" />
        {footnote && <p className="mt-2 text-[12px] text-ink-muted/80">{footnote}</p>}
      </div>
      <BankPickerCard />
    </div>
  )
}
